<% if (provider.gid == validated_provider.gid) { %>
  <div <% if (validated_provider.image_url) { %>style="background-image: url(<%= validated_provider.image_url %>);"<% } %> class="item-icon validated-provider-icon"></div>
  <div class="item-attribute__name"><%= I18n.labels.doctor %></div>
<% } else { %>
  <div <% if (validated_provider.image_url) { %>style="background-image: url(<%= validated_provider.image_url %>);"<% } %> class="item-icon validated-provider-icon attention"></div>
  <div <% if (provider.image_url) { %>style="background-image: url(<%= provider.image_url %>);"<% } %> class="item-icon provider-icon"></div>
  <div class="item-attribute__name"><%= I18n.summary.updated_doctor.replace('%{doctor}', I18n.labels.doctor) %></div>
<% } %>

<div class="item-attribute__content">
  <div class="doctor-name" translate="no">
  <%- validated_provider.name %>
  </div>
  <div class="doctor-specialty">
    <% if (validated_provider.provider_credentials_for_label) { %>
      <%- validated_provider.provider_credentials_for_label.join(', ') %>
    <% } %>
  </div>
</div>
